import {Presenter} from '../../../Support/with_presenter';
import {loadingResponse, NetworkResult} from '../../../Network/NetworkResult';
import {Report} from '../../../Models/Report';
import {ReportService} from '../../../Network/ReportService';
import {ReportType} from '../../../Models/ReportType';

export class ReportShowContainerPresenter implements Presenter {
    public result: NetworkResult<Report> = loadingResponse();

    public get type(): ReportType | null {
        if (this.result.status === 'success') {
            const url = new URL(window.location.href);
            const queryStringType = url.searchParams.get('type');
            if (Object.values(ReportType).includes(queryStringType as ReportType)) {
                return queryStringType as ReportType;
            }

            return this.result.data.type;
        }

        return null;
    }

    constructor(private reportService: ReportService) {}

    public mount(): void {
        /* Noop */
    }

    public unmount(): void {
        /* Noop */
    }

    public async load(id: string): Promise<void> {
        this.result = await this.reportService.get(id);
    }
}
